<template>
  <v-dialog :value="value" persistent max-width="750" @click:outside="closeDialog()">
    <v-card color="fill">
      <v-container class="shipperCon">
        <v-card-title class="my-0 py-0 pt-0 heading-6">
          <v-row justify="space-between" class="my-2">
            <v-col class="ma-0 pa-0 pb-4" align="start">
              <div class="text-no-wrap">
                Item #{{ selectedItem.item_id }} Components
              </div>
            </v-col>
            <v-col class="pa-0 ma-0 pr-1" align="end">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="generateCSV()" v-bind="attrs" v-on="on">
                    <v-icon dense>mdi-download</v-icon>
                  </v-btn>
                </template>
                <span>Export CSV</span>
              </v-tooltip>
              <v-btn icon @click="closeDialog()">
                <v-icon dense>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <template>
          <v-data-table
            :headers="headers"
            :items.sync="selectedItem.components"
            item-key="uuid"
            hide-default-footer
            fixed-header
            dense>
            <template v-slot:[`item.upc`]="{ item }">
              <td class="text-no-wrap">{{ item.component_upc }}</td>
            </template>
            <template v-slot:[`item.description`]="{ item }">
              <td class="text-no-wrap">{{ item.component_description ? item.component_description : '-' }}</td>
            </template>
            <template v-slot:[`item.shelf_unit`]="{ item }">
              <td class="text-no-wrap">{{ item.shelf_unit }}</td>
            </template>
          </v-data-table>
        </template>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>

import { fullWidthTable } from '@/mixins/table'

export default {
  name: 'ShipperComponentModal',
  props: [
    'value',
    'selectedItem'
  ],
  mixins: [fullWidthTable],
  data () {
    return {
      headers: [
      { text: 'UPC', value: 'upc', show: true },
      { text: 'Description', value: 'description', show: true },
      { text: 'Qty Per Shipper', value: 'shelf_unit', show: true }
      ]

    }
  },
  methods: {
    generateCSV () {
      const items = this.selectedItem.components
      if (!items || items.length === 0) {
        return
      }

      const headers = this.headers.filter(h => h.show).map(h => h.text)

      const sanitizeCSVField = (field) => {
        if (field === null || field === undefined) return '-'
        return `"${String(field).replace(/"/g, '""').replace(/[\n\r]+/g, ' ')}"`
      }

      const data = items.map(item => [
        sanitizeCSVField(item.component_upc),
        sanitizeCSVField(item.component_description),
        sanitizeCSVField(item.shelf_unit)
      ])

      let csvContent = 'data:text/csv;charset=utf-8,'
      csvContent += [
        headers.join(','),
        ...data.map(e => e.join(','))
      ].join('\n')

      const encodedUri = encodeURI(csvContent)
      const link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute('download', `item-${this.selectedItem.item_id}-components.csv`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    closeDialog() {
      this.$emit('closeDialog')
    }
  }
}
</script>
<style>
.shipperCon .theme--light.v-data-table .v-data-table-header th {
    color: #fff !important;
    background-color: #385F73 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ShipperComponentModal.vue